import BaseSobrevivenciaRequest from "../BaseSobrevivenciaRequest";
export default class ReenvioBiometricaRequest extends BaseSobrevivenciaRequest {
    constructor(
      public numId: string,
      public numPreSolicitud: number,
      public codUsuario: string,
      public canal: string="PortalBe",
    ) {
      super(canal, codUsuario, numPreSolicitud);
    }
  }
  